import styled from '@emotion/styled'
import {theme} from '../../../../../../accountManagement/theme'

/* ── Optional "note to client" collapsible ────────────────────────────────── */

export const NotesSection = styled.div`
  width: 80%;
  border: 1px solid ${theme.colors.border.default};
  border-radius: ${theme.radii.md};
  background: ${theme.colors.bg.primary};
  overflow: hidden;
`

export const NotesToggle = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 10px 12px;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.semibold};
  color: ${theme.colors.text.primary};

  &:focus-visible {
    outline: 2px solid ${theme.colors.border.focus};
    outline-offset: -2px;
  }
`

export const NotesOptionalTag = styled.span`
  font-size: ${theme.fontSizes.xs};
  font-weight: ${theme.fontWeights.regular};
  color: ${theme.colors.text.muted};
`

export const NotesCaret = styled.span`
  margin-left: auto;
  display: inline-flex;
  color: ${theme.colors.text.secondary};
  transform: ${({isOpen}) => (isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.15s ease;
`

export const NotesBody = styled.div`
  padding: 0 12px 10px;
`

export const NotesTextarea = styled.textarea`
  width: 100%;
  min-height: 84px;
  resize: vertical;
  padding: 8px 10px;
  border: 1px solid ${theme.colors.border.light};
  border-radius: ${theme.radii.sm};
  font-family: inherit;
  font-size: ${theme.fontSizes.sm};
  color: ${theme.colors.text.primary};
  background: ${theme.colors.bg.primary};

  &::placeholder {
    color: ${theme.colors.text.muted};
  }

  &:focus {
    outline: none;
    border-color: ${theme.colors.border.focus};
  }
`

/* Shown when the proposal link fails to reach the client. */
export const SendErrorBanner = styled.p`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 80%;
  margin: 0;
  padding: 8px 12px;
  border-radius: ${theme.radii.md};
  background: ${theme.colors.status.danger.bg};
  border: 1px solid ${theme.colors.status.danger.border};
  color: ${theme.colors.status.danger.text};
  font-size: ${theme.fontSizes.sm};
  line-height: 1.45;
`

export const NotesFootRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 4px;
  font-size: ${theme.fontSizes.xs};
  color: ${theme.colors.text.muted};
`
